// react documenation used: https://react.dev/learn
// axios documentation used: https://axios-http.com/docs/intro
// w3schools documentation was used for windows update: https://www.w3schools.com/js/js_window_location.asp
import React, { useState, useEffect, useRef } from "react";
import Nav from "../../layout/navBar/navBar";
import Recent from "../../layout/recentBar/recentBar";
import styles from "./accountPage.module.css";
import axios from "axios";
import AdminPanel from "../../layout/adminPanel/AdminPanel";

function AccountPage() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showAdmin, setShowAdmin] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;

  const isMounted = useRef(true);

  useEffect(() => {
    // used to debug an error that occured when running project locally
    isMounted.current = true;

    const fetchUserProfile = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(`${apiUrl}/api/users/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        // Only updates when component is mounted
        if (isMounted.current) {
          setShowAdmin(response.data.isAdmin);
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    fetchUserProfile();

    // the following functions check if the parameters sent fromt he backend server giving the right notification respectively
    const params = new URLSearchParams(window.location.search);
    if (params.get("githubLinked") === "true") {
      alert("GitHub account linked successfully!");
    }

    const params2 = new URLSearchParams(window.location.search);
    if (params2.get("gitlabLinked") === "true") {
      alert("GitLab account linked successfully!");
    }

    return () => {
      isMounted.current = false;
    };
  });

  const handleUpdate = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    try {
      await axios.put(
        `${apiUrl}/api/users/update`,
        {
          firstName,
          lastName,
          email,
          password,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert("User details updated successfully.");
    } catch (error) {
      console.error("Update error:", error);
      alert("Failed to update user details.");
    }
  };

  // the window location function was used instead of axios as there were cors errors when trying to use axios request
  const handleGitHubConnect = () => {
    const token = localStorage.getItem("token");
    window.location.href = `${apiUrl}/api/requests/github?jwtToken=${token}`;
  };

  const handleGitLabConnect = () => {
    const token = localStorage.getItem("token");
    window.location.href = `${apiUrl}/api/requests/gitlab?jwtToken=${token}`;
  };

  return (
    <div>
      <Nav />
      <div className={styles.home}>
        <header className={styles.header}></header>
        <main className={styles.mainContent}>
          <section className={styles.recentlyAccessed}>
            <Recent />
          </section>
          <section className={styles.sharedRepositories}>
            <div className={styles.topSection}>
              <h2>My Account</h2>
              <div className={styles.connectButtonContainer}>
                <button
                  type="button"
                  onClick={handleGitHubConnect}
                  className={styles.connectButton}
                >
                  {" "}
                  <img src="/github.png" alt="GitHub" />
                  Connect to GitHub
                </button>
                <button
                  type="button"
                  onClick={handleGitLabConnect}
                  className={styles.connectButton}
                >
                  {" "}
                  <img src="/gitlab.png" alt="GitLab" />
                  Connect to GitLab
                </button>
              </div>
            </div>
            <div className={styles.reposContainer}>
              <form onSubmit={handleUpdate} className={styles.accountPageForm}>
                <h1>Update Details</h1>
                <div className={styles.accountPageFormGroup}>
                  <input
                    type="text"
                    id="firstName"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                    placeholder="First Name:"
                  />
                </div>
                <div className={styles.accountPageFormGroup}>
                  <input
                    type="text"
                    id="lastName"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                    placeholder="Last Name:"
                  />
                </div>
                <div className={styles.accountPageFormGroup}>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="Email:"
                  />
                </div>
                <div className={styles.accountPageFormGroup}>
                  <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    placeholder="New Password:"
                  />
                </div>
                <button type="submit">Update</button>
              </form>
              {showAdmin && <AdminPanel />}
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}

export default AccountPage;
